(function(){    
    angular.module('tmx-app')
        .directive('profileMenu',profileMenuDirective);    
    function profileMenuDirective() {
        return {
            restrict: 'E',
            scope: {
                main:"=",
                currentuser:"="
            },
            templateUrl: 'common/directives/profilemenu/profilemenu.html',
            controller: ['$state','$scope','$translate','menu','tmxResource','cacheStore', ProfileMenuCtrl],
            controllerAs:'profileMenuCtrl'
        };
    }
    
    function ProfileMenuCtrl($state,$scope, $translate,menu,tmxResource,cacheStore){        
        $scope.updateImage = function(){            
            $scope.data = {                
                imageData: {
                    old: true,
                    image: $scope.currentuser.ImageUrl,
                    url: $scope.currentuser.ImageUrl
                }
            }   
        }    

        $scope.open=function(section){

            if(section.icon=="language"){
                $translate.use(section.language);
            }
            else if(section.name=="ProfileLink"){
                $state.go("private."+section.route.toLowerCase(),{"Id":$scope.currentuser.Id});
            }
            else{
                menu.selectPage(section);
            }
        }

        setLoggedInUserInfo();

        function setLoggedInUserInfo(){            
            var GetInfoOfLoggedInUser =  cacheStore.get("GetInfoOfLoggedInUser");	
            if(!GetInfoOfLoggedInUser){
                tmxResource("user").getByAction('GetInfoOfLoggedInUser', false, undefined, undefined, undefined, undefined, true).then(function (response) {                        
                    cacheStore.set("GetInfoOfLoggedInUser", angular.copy(response.data));
                    $scope.currentuser.RoleName = response.data.RoleName;
                    $scope.currentuser.UserName = response.data.userName;            
                });
            }
            else{
                $scope.currentuser.RoleName = GetInfoOfLoggedInUser.RoleName;
                $scope.currentuser.UserName = GetInfoOfLoggedInUser.userName;   
            }
        }
        
    }
})();